import FontSizes from 'scss/variables/_fontSizes.scss';
import AppConfig from 'config/appConfig';

import Colors from './scss/_colors.scss';

const eui = {
  UTSelect: {
    underline: {
      hover: { borderBottom: `1px solid ${Colors.gray}` },
      disabled: { borderBottom: `1px solid ${Colors.disabledGray}` },
      focused: { borderBottom: `2px solid ${Colors.primary}` },
      base: { borderBottom: `2px solid ${Colors.primary}` },
      unfocused: { borderBottom: `1px solid ${Colors.gray}` }
    },
    formLabel: {
      color: Colors.gray,
      errorColor: Colors.gray,
      focusedColor: Colors.primary,
      focusedErrorColor: Colors.errorRed
    }
  },
  UTTextInput: {
    underline: {
      hover: { borderBottom: `1px solid ${Colors.gray}` },
      disabled: { borderBottom: `1px solid ${Colors.disabledGray}` },
      focused: { borderBottom: `2px solid ${Colors.primary}` },
      base: { borderBottom: `2px solid ${Colors.primary}` },
      unfocused: { borderBottom: `1px solid ${Colors.gray}` }
    },
    formLabel: {
      color: Colors.gray,
      errorColor: Colors.gray,
      focusedColor: Colors.primary,
      focusedErrorColor: Colors.errorRed
    }
  },
  UTLabel: {
    base: {
      fontSize: FontSizes.medium
    },
    primary: {
      color: Colors.primary
    },
    secondary: {
      color: Colors.tertiary
    },
    alternative: {
      color: Colors.secondary
    },
    gray: {
      color: Colors.gray
    },
    error: {
      color: Colors.errorRed
    }
  },
  UTButton: {
    base: {
      backgroundColor: Colors.secondary,
      color: Colors.white,
      borderRadius: AppConfig.buttonRadius,
      hover: {
        backgroundColor: Colors.lightPrimaryHover
      }
    },
    baseText: {
      color: Colors.lightPrimary,
      hover: {
        backgroundColor: Colors.flatLightPrimaryHover
      }
    },
    baseOutlined: {
      borderColor: Colors.lightPrimary,
      borderRadius: 50,
      color: Colors.lightPrimary,
      hover: {
        backgroundColor: Colors.flatLightPrimaryHover
      }
    },
    secondary: {
      backgroundColor: Colors.tertiary,
      color: Colors.white,
      hover: {
        backgroundColor: Colors.tertiaryHover
      }
    },
    secondaryText: {
      color: Colors.tertiary,
      hover: {
        backgroundColor: Colors.flatTertiaryHover
      }
    },
    secondaryOutlined: {
      borderColor: Colors.tertiary,
      color: Colors.tertiary,
      hover: {
        backgroundColor: Colors.flatTertiaryHover
      }
    },
    alternative: {
      backgroundColor: Colors.secondary,
      color: Colors.white,
      hover: {
        backgroundColor: Colors.secondaryHover
      }
    },
    alternativeText: {
      color: Colors.secondary,
      hover: {
        backgroundColor: Colors.flatSecondaryHover
      }
    },
    alternativeOutlined: {
      borderColor: Colors.secondary,
      color: Colors.secondary,
      hover: {
        backgroundColor: Colors.flatSecondaryHover
      }
    },
    gray: {
      backgroundColor: Colors.gray,
      color: Colors.white
    },
    grayText: {
      color: Colors.gray
    },
    grayOutlined: {
      borderColor: Colors.gray,
      color: Colors.gray
    },
    loading: {
      color: Colors.lightPrimary
    }
  },
  Loading: {
    base: {
      color: Colors.loadingBase,
      size: 85,
      thickness: 1.5
    }
  },
  Fonts: {
    fontFamily: AppConfig.fontFamily,
    xxxsmall: FontSizes.xxxsmall,
    xxsmall: FontSizes.xxsmall,
    xsmall: FontSizes.xsmall,
    small: FontSizes.small,
    medium: FontSizes.medium,
    large: FontSizes.large,
    xlarge: FontSizes.xlarge,
    xxlarge: FontSizes.xxlarge,
    xxxlarge: FontSizes.xxxlarge,
    title: FontSizes.title,
    largeTitle: FontSizes.largeTitle
  },
  UTDialog: {
    container: {
      padding: '20px 10px'
    },
    mainTitle: {
      display: 'flex',
      marginRight: '60px'
    },
    warning: {
      maxWidth: '260px',
      padding: '24px 24px 0'
    },
    acceptButton: {
      margin: '0 10px'
    }
  },
  UTSwitch: {
    container: {
      margin: '10px 0'
    },
    sliderBack: {
      backgroundColor: Colors.grayLight2,
      border: `1px solid ${Colors.grayLight2}`,
      checkedSlider: {
        border: `1px solid ${Colors.primary}`,
        backgroundColor: Colors.primary,
        hover: {
          border: `1px solid ${Colors.tertiaryHover}`,
          backgroundColor: Colors.tertiaryHover
        }
      },
      boxShadow: `0 2px 2px ${Colors.grayLight2}`
    },
    slider: {
      width: '20px',
      height: '20px',
      backgroundColor: Colors.white,
      checkedSlider: {
        backgroundColor: Colors.white,
        transform: 'translateX(28px)'
      },
      boxShadow:
        '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)'
    },
    checkedText: {
      color: Colors.white,
      fontSize: '12.8px',
      fontWeight: '500'
    },
    uncheckedText: {
      fontSize: '12.8px',
      fontWeight: '500'
    }
  }
};
const mui = {
  typography: {
    fontFamily: AppConfig.fontFamily
  },
  overrides: {
    MuiInput: {
      input: {
        fontSize: FontSizes.medium,
        '&:disabled': {
          color: Colors.disabledGray
        }
      },
      underline: {
        // On hover
        '&:hover:not($disabled):not($focused):not($error):before': {
          borderBottom: `1px solid ${Colors.gray2}`
        },
        // After submitting error without hover
        '&$disabled:before': {
          borderBottom: `1px dotted ${Colors.disabledGray}`
        },
        // Without hover
        '&:before': {
          borderBottom: `1px solid ${Colors.gray2}`
        },
        // Border growth
        '&$focused:after': {
          borderBottom: `2px solid ${Colors.lightPrimary}`
        },
        // Border growth and dissapear
        '&:after': {
          borderBottom: `2px solid ${Colors.lightPrimary}`
        }
      }
    },
    MuiFormLabel: {
      root: {
        '&$error': {
          color: Colors.gray
        },
        '&$focused': {
          color: Colors.lightPrimary,
          '&$error': {
            color: Colors.errorRed
          }
        },
        color: Colors.gray,
        fontSize: FontSizes.medium
      }
    },
    MuiFormHelperText: {
      root: {
        fontSize: FontSizes.small
      }
    },
    MuiPaper: {
      root: {
        overflowX: 'auto'
      }
    },
    MuiCheckbox: {
      root: {
        padding: 12
      },
      colorSecondary: {
        '&:hover': { backgroundColor: Colors.flatLightPrimaryHover },
        '&$checked': {
          color: Colors.secondary,
          '&:hover': { backgroundColor: Colors.flatLightPrimaryHover }
        },
        '&$disabled': {
          color: Colors.disabledGray
        }
      }
    }
  }
};

export default { eui, mui };
